import { render, staticRenderFns } from "./AppTabbar.vue?vue&type=template&id=49fd9fdc"
import script from "./AppTabbar.vue?vue&type=script&lang=js"
export * from "./AppTabbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports